import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  // {
  //   path: '*',
  //   redirect: '/'
  // },
  
  {
    path:'/',
    name: 'home',
    component: () => import('@/view/home'),
    meta: {
      title: '2022高招面对面'
    }
  },
];

// add route path
// routes.forEach(route => {
//   route.path = route.path || '/' + (route.name || '');
// });

const router = new Router({mode:'history',  base: process.env.VUE_APP_BASE_URL, routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
